<template>
    <div class="sankey-v2">
        <div class="chart" :class="{ 'is-loading': isLoading }" ref="chart" />
        
        <!-- 
            Allow some extra content to be rendered inside the chart element
            complete chart was build prior to a more stripped version, certain elements are styled with the assumption of them being rendered inside our sankey-v2 element 
        -->
        <loading-box v-if="isLoading" />

        <slot />
    </div>
</template>

<script>
import { errorGrowl } from "@core/Util/growler";

import createChart from './draw-chart';

import LoadingBox from "@core/Components/Util/LoadingBox";

export default {
    name: "sankey-v2",
    
    components: {
        LoadingBox
    },
    
    props: {
        data: {
            type: Array,
            required: true
        },
        
        types: {
            type: Array,
            required: true
        },
        
        isLoading: {
            type: Boolean,
            required: false,
            default: false
        },

        highlightMode: {
            type: String,
            required: false
        },

        selectedBrickId: {
            type: String,
            required: false
        },

        tagRouteType: {
            type: String,
            required: false
        }
    },
    
    data() {
        return {
            activeChart: undefined
        }
    },
    
    computed: {
        chartContent() {
            return {
                data: this.data,
                types: this.types
            }
        }
    },

    watch: {
        async chartContent(newContent) {
            await this.renderChart(newContent.data, newContent.types);
        },
        
        activeChart(value){
            //selectedNodeId/highlightMode may be selected prior to our chart having been rendered
            //when a selectedNodeId was provided prior to chart render, the nodeId is preselected. Preselected nodes get autofocus.
            if(this.selectedBrickId) {
                value.selectBrick(this.selectedBrickId);
                value.centerBrick(this.selectedBrickId);
            }

            if(this.highlightMode) value.setHighlightMode(this.highlightMode);
            // value.setDisplayGoalRoutes(this.displayGoalRoutes);
        },
        selectedBrickId(value) {
            if(this.activeChart){
                this.activeChart.selectBrick(value);
            }
        },
        highlightMode(value){
            if(this.activeChart){
                this.activeChart.setHighlightMode(value);
            }
        }
    },
    
    beforeDestroy() {
        if(this.activeChart){
            this.activeChart.destroy();
        }
    },
    
    methods: {
        async renderChart(data, types) {
            try {
                if(this.activeChart) {
                    await this.refreshChart(data, types);
                } else {
                    await this.initializeChart(data, types);
                }

                this.activeChart.setHighlightMode(this.highlightMode);
            } catch(e) {
                console.error(e);
                errorGrowl(e);
            }
        },
        
        async refreshChart(data, types) {
            await this.activeChart.setData({
                nodes: data,
                types: types
            });
        },
        
        async initializeChart(data, types){
            this.activeChart = await createChart(
                this.$refs['chart'],
                {
                    nodes: data,
                    types: types
                },
                {
                    onNodeSelected: brickId => {
                        this.$emit('update:selectedBrickId', brickId);
                        
                        //Bit hacky, give our parent component a single tick to update their selected brick
                        //if our parent component hasn't updated their selected brick, reset the selected brick
                        //back to the value provided by our parent component
                        //this allows for displaying a static selection
                        this.$nextTick(() => this.activeChart.selectBrick(this.selectedBrickId));
                    },
                    onDisplayGoalRoutesChanged: displayGoalRoutes => this.$emit('update:displayGoalRoutes', displayGoalRoutes)
                }
            );
        },
    }
}
</script>

<style src="./chart-content.scss" lang="scss" />
<style src="./sankey-v2.scss" scoped lang="scss" />